import { useState } from 'react';
import { useTheme } from 'styled-components';
import { createContainer } from 'unstated-next';
const useDropzoneImpl = ({ initialFiles = [] } = { initialFiles: [] }) => {
    const { color } = useTheme();
    const colors = {
        successBorder: color.stroke.celebratory.text.on.background,
        errorBorder: color.stroke.critical.text.on.subtle,
        focusBorder: color.effect.focus.outline.on.background,
        defaultBorder: color.stroke.neutral.border.interaction.secondary.on.background,
    };
    const [files, setFiles] = useState(initialFiles);
    const [errors, setErrors] = useState([]);
    const [borderColor, setBorderColor] = useState(colors.defaultBorder);
    return { files, setFiles, errors, setErrors, colors, borderColor, setBorderColor };
};
const DropzoneContainer = createContainer(useDropzoneImpl);
DropzoneContainer.Provider.displayName = 'DropzoneProviderImpl';
export const DropzoneProvider = DropzoneContainer.Provider;
export const useDropzone = DropzoneContainer.useContainer;
//# sourceMappingURL=DropzoneProvider.client.js.map